'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _feiseanna = require('../../../../../feiseanna');

var _feiseanna2 = _interopRequireDefault(_feiseanna);

var _newFeisGrant = require('../../../../../new-feis-grant');

var _newFeisGrant2 = _interopRequireDefault(_newFeisGrant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.personnel', ['ngMaterial', 'ui.router', 'ifeis.feiseanna', 'ifeis.new-feis-grant', 'ifeis.router-history']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.personnel', {
    url: '/personnel',
    template: require('./tpl.html'),
    controller: 'FeisPersonnelController',
    ncyBreadcrumb: {
      label: 'Personnel',
      parent: 'feiseanna.one.admin.manager'
    }
  });
}).controller('FeisPersonnelController', function ($scope, feis, fFeisService, $mdDialog, fFeisGrantDialog) {
  $scope.feis = feis;

  function refresh() {
    return fFeisService.personnel(feis.id).then(function (personnel) {
      $scope.personnel = personnel;
      return personnel;
    });
  }

  $scope.create = function () {
    fFeisGrantDialog().then(function (grant) {
      return fFeisService.createGrant(feis.id, grant);
    }).then(function () {
      return refresh();
    });
  };

  $scope.delete = function ($event, grant) {
    var dialog = $mdDialog.confirm().title('Are you sure?').textContent('This person will no longer enjoy any of the privileges associated with that role.').cancel('Cancel').targetEvent($event).ok('Delete');

    $mdDialog.show(dialog).then(function () {
      return fFeisService.revokeGrant(feis.id, grant.id);
    }).then(function () {
      return refresh();
    });
  };

  refresh();
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/personnel/index.js
// module id = 549
// module chunks = 0